import { useWeb3ModalProvider } from '@web3modal/ethers/vue';
import { BrowserProvider, type ContractTransaction } from 'ethers';
import { useEnvs } from '#imports';
import { BigNumber } from 'bignumber.js';
import type { ContractCallParams } from '~/types/Web3Provider';

export default () => {
  const { walletProvider } = useWeb3ModalProvider();
  const { blockchain } = useEnvs();
  const { getSigner } = useProvider();

  const sendContractMethod = async <T extends Record<any, any>, M extends keyof T>(
    sendParams: ContractCallParams<T, M>,
    onConfirmation?: (confirmations?: number) => void
  ) => {
    const transaction: ContractTransaction = await sendParams.contract
      .getFunction(sendParams.methodName)
      .populateTransaction(...sendParams.args);

    if (walletProvider.value && transaction) {
      const provider = new BrowserProvider(walletProvider.value);
      const signer = await getSigner();
      const estimateGas = await signer.estimateGas(transaction);
      const currentGasPrice = (await provider.getFeeData()).gasPrice;
      const sending = await signer.sendTransaction({
        ...transaction,
        gasPrice: currentGasPrice,
        gasLimit: BigNumber(estimateGas.toString()).multipliedBy(1.25).decimalPlaces(0).toString()
      });

      if (onConfirmation) {
        provider.on('block', async () => {
          const confirmations = await sending.confirmations();
          if (confirmations <= blockchain.minConfirmationsCount) onConfirmation(confirmations);
          if (Number(confirmations) >= blockchain.minConfirmationsCount) {
            provider.off('block');
            return;
          }
        });
      }

      return sending;
    }
  };

  return { sendContractMethod };
};
